import styled from 'styled-components';

export const DraggableContainer = styled.div`
  width: 100%;
  background-color: white;
  border-radius: 10px;
  box-shadow: lightgray 0px 0px 24px 5px;
  border: 2px solid lightgray;
  overflow: auto;
  resize: vertical !important;

  @media only screen and (max-width: 960px) {
    width: 100%;
    margin-right: 0;
    margin-bottom: 12px;
  }
`;

export const TopBar = styled.div`
  padding: 12px 5px 12px 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #d8d8d8;
  i {
    font-size: 18px;
    cursor: pointer;
  }
  @media only screen and (max-width: 1600px) {
    height: 5.3em;
  }
  @media only screen and (max-width: 960px) {
    height: auto;
  }
  @media only screen and (max-width: 792px) {
    height: 5.3em;
  }
  @media only screen and (max-width: 655px) {
    height: auto;
  }
`;

export const Left = styled.div`
  display: flex;
  align-items: center;
  h5 {
    margin: 3px 12px 0 5px;
  }
  .count {
    color: red;
    margin: 0;
    margin-right: 8px;
    font-weight: bold;
    border: 1px solid red;
    border-radius: 50%;
    padding: 3px 9px;
  }
`;

export const Right = styled.div`
  display: flex;
  align-items: center;
`;

export const Content = styled.div`
  padding: 12px 18px;
  display: flex;
  justify-content: center;
  @media only screen and (max-width: 1440px) {
    padding: 12px;
  }
`;
